// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderView_header__container__YaL-S {
  height: 6vh;
  background: var(--header);
  color: #fff;
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
}

.orderView_header__text__LNXpf {
  width: 100%;
  text-align: left;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  padding-left: 1rem;
}

.orderView_button__container__9Rlzt {
  float: right;
  display: flex;
  flex-direction: row;
  padding-right: 1rem;
}

.orderView_button__5x65W {
  padding-right: 1rem;
}

/* All three divs */
.orderView_overview__container__V-L4O {
  display: flex;
  justify-content: space-between;
  padding: 2rem;
}

/* First div */
.orderView_details__container__aBdYY {
  width: 22vw;
}

.orderView_details__titel__FtkOv {
  color: white;
  background: #007474;
  padding: 0.2rem 0 0.2rem 1rem;
  font-weight: 700;
  font-size: 18px;
}

.orderView_details__container_content__V4hgV {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
}

.orderView_details__column_author__m-DVM {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0rem 0.8rem 0.2rem;
}

.orderView_details__column_order__Kwsfc {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.4rem 0.2rem;
}

.orderView_details__column_currency__L5D2n {
  display: flex;
  flex-direction: column;
  padding: 0.8rem 0 0 0rem;
}

.orderView_details__column_account__Ne9AA {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.8rem 0;
}

.orderView_details__column_user__wm1vD {
  display: flex;
  flex-direction: column;
  padding: 0 0 0.8rem 0;
}

.orderView_details__column_shipping__cJtre {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.8rem 0;
}

.orderView_details__column_leadtime__4KU2u {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.8rem 0;
}

.orderView_details__column_state__hgXSJ {
  display: flex;
  flex-direction: column;
}

/* 2nd div */
.orderView_shipping__container__3z4c6 {
  width: 20vw;
}

.orderView_shipping__title__a48dS {
  color: white;
  background: #007474;
  padding: 0.2rem 0 0.2rem 1rem;
  font-weight: 700;
  font-size: 18px;
}

.orderView_shipping__container_content__Z1pHA {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-right: 1rem;
}

.orderView_shipping__column_type__l8O1s {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0rem 0.8rem 0.2rem;
}

.orderView_shipping__column_company__bqvgk {
  display: flex;
  flex-direction: column;
  padding: 0 0 0.8rem 0.2rem;
}

.orderView_shipping__column_email__Ox8Ii {
  display: flex;
  flex-direction: column;
  padding: 0 0 0.8rem 0.2rem;
}

.orderView_shipping__column_address__00A3K {
  display: flex;
  flex-direction: column;
  padding: 0 0 0.8rem 0.2rem;
}

.orderView_shipping__column_shipment__ndnpA {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.8rem 0;
}

/* 3rd div */
.orderView_payment__container__-e6fs {
  width: 21vw;
}

.orderView_payment__title__o37xq {
  color: white;
  background: #007474;
  padding: 0.2rem 0 0.2rem 1rem;
  font-weight: 700;
  font-size: 18px;
}

.orderView_payment__container_content__g7Nt7 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-right: 1rem;
}

.orderView_payment__column_type__gKQ5C {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0rem 0.8rem 0.2rem;
}

.orderView_table__header__aWt9W {
  background: #007474;
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Styles/orderView.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".header__container {\n  height: 6vh;\n  background: var(--header);\n  color: #fff;\n  padding-top: 1rem;\n  display: flex;\n  justify-content: space-between;\n}\n\n.header__text {\n  width: 100%;\n  text-align: left;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #fff;\n  padding-left: 1rem;\n}\n\n.button__container {\n  float: right;\n  display: flex;\n  flex-direction: row;\n  padding-right: 1rem;\n}\n\n.button {\n  padding-right: 1rem;\n}\n\n/* All three divs */\n.overview__container {\n  display: flex;\n  justify-content: space-between;\n  padding: 2rem;\n}\n\n/* First div */\n.details__container {\n  width: 22vw;\n}\n\n.details__titel {\n  color: white;\n  background: #007474;\n  padding: 0.2rem 0 0.2rem 1rem;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.details__container_content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.details__column_author {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0rem 0.8rem 0.2rem;\n}\n\n.details__column_order {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0 0.4rem 0.2rem;\n}\n\n.details__column_currency {\n  display: flex;\n  flex-direction: column;\n  padding: 0.8rem 0 0 0rem;\n}\n\n.details__column_account {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0 0.8rem 0;\n}\n\n.details__column_user {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0.8rem 0;\n}\n\n.details__column_shipping {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0 0.8rem 0;\n}\n\n.details__column_leadtime {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0 0.8rem 0;\n}\n\n.details__column_state {\n  display: flex;\n  flex-direction: column;\n}\n\n/* 2nd div */\n.shipping__container {\n  width: 20vw;\n}\n\n.shipping__title {\n  color: white;\n  background: #007474;\n  padding: 0.2rem 0 0.2rem 1rem;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.shipping__container_content {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.shipping__column_type {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0rem 0.8rem 0.2rem;\n}\n\n.shipping__column_company {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0.8rem 0.2rem;\n}\n\n.shipping__column_email {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0.8rem 0.2rem;\n}\n\n.shipping__column_address {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0.8rem 0.2rem;\n}\n\n.shipping__column_shipment {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0 0.8rem 0;\n}\n\n/* 3rd div */\n.payment__container {\n  width: 21vw;\n}\n\n.payment__title {\n  color: white;\n  background: #007474;\n  padding: 0.2rem 0 0.2rem 1rem;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.payment__container_content {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.payment__column_type {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0rem 0.8rem 0.2rem;\n}\n\n.table__header {\n  background: #007474;\n  color: #fff;\n  font-weight: bold;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header__container": `orderView_header__container__YaL-S`,
	"header__text": `orderView_header__text__LNXpf`,
	"button__container": `orderView_button__container__9Rlzt`,
	"button": `orderView_button__5x65W`,
	"overview__container": `orderView_overview__container__V-L4O`,
	"details__container": `orderView_details__container__aBdYY`,
	"details__titel": `orderView_details__titel__FtkOv`,
	"details__container_content": `orderView_details__container_content__V4hgV`,
	"details__column_author": `orderView_details__column_author__m-DVM`,
	"details__column_order": `orderView_details__column_order__Kwsfc`,
	"details__column_currency": `orderView_details__column_currency__L5D2n`,
	"details__column_account": `orderView_details__column_account__Ne9AA`,
	"details__column_user": `orderView_details__column_user__wm1vD`,
	"details__column_shipping": `orderView_details__column_shipping__cJtre`,
	"details__column_leadtime": `orderView_details__column_leadtime__4KU2u`,
	"details__column_state": `orderView_details__column_state__hgXSJ`,
	"shipping__container": `orderView_shipping__container__3z4c6`,
	"shipping__title": `orderView_shipping__title__a48dS`,
	"shipping__container_content": `orderView_shipping__container_content__Z1pHA`,
	"shipping__column_type": `orderView_shipping__column_type__l8O1s`,
	"shipping__column_company": `orderView_shipping__column_company__bqvgk`,
	"shipping__column_email": `orderView_shipping__column_email__Ox8Ii`,
	"shipping__column_address": `orderView_shipping__column_address__00A3K`,
	"shipping__column_shipment": `orderView_shipping__column_shipment__ndnpA`,
	"payment__container": `orderView_payment__container__-e6fs`,
	"payment__title": `orderView_payment__title__o37xq`,
	"payment__container_content": `orderView_payment__container_content__g7Nt7`,
	"payment__column_type": `orderView_payment__column_type__gKQ5C`,
	"table__header": `orderView_table__header__aWt9W`
};
export default ___CSS_LOADER_EXPORT___;
